import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './plugins/vue-i18n'
import './plugins/vue-custom-components'
import './plugins/vue-file-agent'
import './plugins/vue-select'
import './plugins/vue-frag'
import './plugins/vue-html'
import './plugins/vee-validate'
import './plugins/vuelidate'
import './plugins/vue-quill-editor'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
// v-contentmenu
import contentmenu from 'v-contextmenu'
Vue.use(contentmenu)
// vue-line-clamp
import VueLineClamp from 'vue-line-clamp'
Vue.use(VueLineClamp, {
  importCss: true
})
// vue-scrollto
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)
// vue confirm dialog
import VueConfirmDialog from 'vue-confirm-dialog'
Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
// vue-perfect-scrollbar
import vuePerfectScrollbar from 'vue-perfect-scrollbar'
Vue.component('vue-perfect-scrollbar', vuePerfectScrollbar)

Vue.config.productionTip = false

export default new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
